"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Modal = void 0;
const react_1 = __importDefault(require("react"));
const ModalBody_1 = require("../../atoms/ModalBody/ModalBody");
const ModalWrapper_1 = require("../../atoms/ModalWrapper/ModalWrapper");
const Modal = ({ open, setOpen, accent, className, closeButton, closeOnBackground, position, children, closeOnEscape, testing, }) => {
    const close = setOpen && (() => setOpen(false));
    return (react_1.default.createElement(ModalWrapper_1.ModalWrapper, { open: open, onBackgroundClick: closeOnBackground ? close : undefined, onEscape: closeOnEscape ? close : undefined, position: position, testing: testing },
        react_1.default.createElement(ModalBody_1.ModalBody, { open: open, onClose: closeButton ? close : undefined, accent: accent, className: className }, children)));
};
exports.Modal = Modal;
